import { useState, useEffect } from 'react';
import { centrosAPI, tiposEstudiosAPI, procesadoresAPI, turnosAPI, categoriasAPI, obrasSocialesAPI, equiposAPI, medicosAPI } from '../../../core/api/api';

export const useCatalogos = () => {
  const [centros, setCentros] = useState([]);
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [procesadores, setProcesadores] = useState([]);
  const [estadosTurno, setEstadosTurno] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [equipos, setEquipos] = useState([]);
  const [equiposCPAP, setEquiposCPAP] = useState([]);
  const [medicos, setMedicos] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    setLoading(true);
    try {
      const [centrosRes, tiposRes, procesadoresRes, estadosRes, categoriasRes, obrasSocialesRes, equiposRes, medicosRes, tecnicosRes] = await Promise.all([
        centrosAPI.getCentros(),
        tiposEstudiosAPI.getTiposEstudios(),
        procesadoresAPI.getProcesadores(),
        turnosAPI.getEstadosSupervisor(),
        categoriasAPI.getCategorias(),
        obrasSocialesAPI.getObrasSociales(),
        equiposAPI.getEquipos(),
        medicosAPI.getMedicos(),
        medicosAPI.getTecnicos(),
      ]);

      const todosEquipos = equiposRes.data || [];
      const equiposRegistro = todosEquipos.filter(equipo => equipo.tipo === 'R');
      const equiposCPAPFiltrados = todosEquipos.filter(equipo => equipo.tipo === 'C');

      setCentros(centrosRes.data || []);
      setTiposEstudios(tiposRes.data || []);
      setProcesadores(procesadoresRes.data || []);
      setEstadosTurno(estadosRes.data || []);
      setCategorias(categoriasRes.data || []);
      setObrasSociales(obrasSocialesRes.data || []);
      setEquipos(equiposRegistro);
      setEquiposCPAP(equiposCPAPFiltrados);
      setMedicos(medicosRes.data || []);
      setTecnicos(tecnicosRes.data || []);
    } catch (err) {
      setError('Error al cargar datos iniciales');
    } finally {
      setLoading(false);
    }
  };

  return {
    centros,
    tiposEstudios,
    procesadores,
    estadosTurno,
    categorias,
    obrasSociales,
    equipos,
    equiposCPAP,
    medicos,
    tecnicos,
    loading,
    error,
  };
};
